<script>
  import PuzFilePicker from '../PuzFilePicker.svelte';
  import GameSession from '../utils/GameSession';
  import { push as navigateTo } from 'svelte-spa-router';

  async function onUpload(e) {
    // create initial game session
    const grid = e.detail;
    const id = await GameSession.createSession(grid);

    // move to the game screen
    navigateTo(`/game/${id}`);
  }

</script>

<PuzFilePicker on:upload={onUpload} />

